import { styled, Theme } from "@mui/material/styles"
import { Checkbox, CheckboxProps } from "@mui/material"
import AddIcon from "components/atoms/_icons/AddIcon"
import RemoveIcon from "components/atoms/_icons/RemoveIcon"
import TickIcon from "components/atoms/_icons/TickIcon"

type Variant = "add" | "select";

interface CustomCheckboxProps extends CheckboxProps {
  variant: Variant;
}

export default function CustomCheckbox(props: CustomCheckboxProps) {
  const { variant = "add" } = props

  return (
    <StyledCheckbox
      sx={{ "&:hover": { bgcolor: "transparent" } }}
      disableRipple
      color="default"
      checkedIcon={ICON_MAP[variant].checked}
      icon={ICON_MAP[variant].unchecked}
      inputProps={{ "aria-label": "Checkbox demo" }}
      {...props}
    />
  )
}

type StyledCheckboxProps = {
  theme?: Theme;
  variant?: Variant;
}

const StyledCheckbox = styled(Checkbox)(({ theme, variant }: StyledCheckboxProps) => ({
  width: "22px",
  height: "22px",
  borderRadius: "50%",
  padding: 0,
  border: variant === "add" ? `1px solid ${theme?.palette?.gray["13"]}` : `1px solid ${theme?.palette?.gray["7"]}`,
  transition: "0.1s",
  backgroundColor: variant === "add" ? "transparent" : theme?.palette?.gray["5"],

  "&.Mui-checked": {
    backgroundColor: variant === "add" ? `${theme?.palette?.gray["13"]} !important` : `${theme?.palette?.success["4"]} !important`,
    border: variant === "add" ? `1px solid ${theme?.palette?.gray["13"]}` : `1px solid ${theme?.palette?.success["4"]}`,

    ...(variant === "select" && {
      "& svg": {
        width: "12px",
        height: "12px"
      },
      "& path": {
        fill: "#FFFFFF"
      }
    })
  }
}))

const IconWrapper = styled("div")(({ theme }) => ({
  width: "16px",
  height: "16px",

  "& svg": {
    width: "100%",
    height: "100%",
    stroke: theme.palette.gray["13"]
  }
}))

const ICON_MAP = {
  add: {
    checked: <RemoveIcon/>,
    unchecked: <IconWrapper><AddIcon/></IconWrapper>
  },
  select: {
    checked: <TickIcon/>,
    unchecked: <></>
  }
}
